import { useState } from "react"
import addbanner from '../../../assets/images/core/CreateBanner.png'
import logo from '../../../assets/images/logos/Jobs_logo.png'

export const JobPost = () => {

    const [previewStat, setPreviewStat] =  useState(false)
    const [statModal, setStatModal]=useState(false)
    const [loader, setLoader] = useState(false)
    const [updateLoader, setUpdateLoader]= useState(false)
    const [deploymentSelected, setDeploymentSelected] = useState('')
    const [employmentSelected, setEmploymentSelected] = useState('')
    const [employmentStatus, setEmploymentStatus] = useState([       
            {id: 1, name: 'Full-Time'},
            {id: 2, name: 'Part-Time'},
            {id: 3, name: 'Temporary'},
            {id: 4, name: 'Casual'},
            {id: 5, name: 'Fixed-Term'},
            {id: 6, name: 'On-Call'},
            {id: 7, name: 'Seasonal'},
            {id: 8, name: 'Intern/Trainee'},
            {id: 9, name: 'Freelancer'},
            {id: 10, name: 'Contractor'},
            {id: 11, name: 'Consultant'},
            {id: 12, name: 'Project-Based'},        
        ])
    
        const [deploymentArrangement, setDeploymentArrangement] = useState([ 
            {id: 1, name: 'Work on site'},
            {id: 2, name: 'Work on site with Field work'},
            {id: 3, name: 'Work from home'},
            {id: 4, name: 'Hybrid terms'},
        ])
    const [form, setForm] = useState ({ type: "create",
    submit: {modal: false, type: '', confirmed: false},
    inputs:{
        name: {value: '', stat: false, msg: '', toggled: false},
        position: {value: '', stat: false, msg: '', toggled: false},
        qualification: [{value: '', stat: false, msg: '', toggled: false}],
        description: [{value: '', stat: false, msg: '', toggled: false}],
        benefits: [{value: '', stat: false, msg: '', toggled: false}],
        banner: {value: null, object: addbanner, name: '', type: 'default', size: 0, updated: false, stat: false, msg: {value: '', stat: false, msg: ''}},
        logo: {value: null, object: logo, name: '', type: 'default', size: 0, updated: false, stat: false, msg: {value: '', stat: false, msg: ''}},
        location: {value: '', stat: false, msg: '', toggled: false},
        overview: {value: '', stat: false, msg: '', toggled: false},
        start_date: {value: 1, stat: false, msg: '', toggled: false},
        end_date: {value: 1, stat: false, msg: '', toggled: false},
        status: {value: '', stat: false, msg: '', toggled: false},
        user_id: {value: 1, stat: false, msg: '', toggled: false},
        company_id: {value: 1, stat: false, msg: '', toggled: false},
        statupdate: {value: 1, stat: false, msg: '', toggled: false},
        deployment: {value: '', stat: false, msg: '', toggled: false},
        employment: {value: '', stat: false, msg: '', toggled: false},
        // project: {value: '', stat: false, msg: '', toggled: false},
    }})

      
 
  return {

    form: {data: form, set: setForm},
    employmentStatus:{data: employmentStatus, set: setEmploymentStatus},
    deploymentArrangement:{data: deploymentArrangement, set: setDeploymentArrangement},
    updateLoader: {data: updateLoader, set: setUpdateLoader},
    previewStat:{data:previewStat, set:setPreviewStat},
    statModal:{data:statModal, set:setStatModal},
    loader:{data: loader, set: setLoader},
    employmentSelected:{data: employmentSelected, set: setEmploymentSelected},
    deploymentSelected: {data: deploymentSelected, set: setDeploymentSelected},

  }
}